module.exports = __webpack_public_path__ + "img/w3_viewed_white.5c8b7b6b.png";